/**
 * 卫星图、放大缩小、全屏
 * 
 * @Author: Focci
 * @Date: 2023-07-13 14:37:30
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-13 14:37:30
 */

import PropTypes from 'prop-types'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit'
import useFullscreen from '@hook/useFullscreen'
import { useMap } from 'react-map-gl'
import ControllerWrapper from './ControllerWrapper'

export default function FullscreenController({
  small = false,
  className,
}) {
  const { current: mapbox } = useMap()
  const container = mapbox.getContainer()
  const { isFullscreen, handle } = useFullscreen(container)
  const iconSx = { fontSize: small ? '1rem' : '1.5rem' }

  return (
    <ControllerWrapper 
      onClick={handle}
      small={small}
      className={className}
    >
      {
        isFullscreen 
          ? <FullscreenExitIcon sx={iconSx} />
          : <FullscreenIcon sx={iconSx} />
      }
    </ControllerWrapper>
  )
}

FullscreenController.propTypes = {
  small: PropTypes.bool,
}
